var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"sps-header-icon",attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M5 8.25L10 13L15 8.25","stroke":_vm.color || 'currentColor',"stroke-width":"1.7","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51a1220e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V2/svg/components/MinimizeIcon.vue
// module id = 5K5O
// module chunks = 0